<template>
  <div>
    <h3 class="multiple_leads--heading">Contact Has Multiple Leads</h3>
    <p class="multiple_leads--text">Please choose a lead below that you would like to attach the inbound comms to the
      left.</p>

    <div
      v-for="record in records"
      :key="record.id"
      class="multiple_leads--lead"
    >
      <record-info
        :record="record"
        :status="status(record)"
        is-large
      ></record-info>

      <button-outlined
        class="mx-auto mb-50"
        @click="attachLeadToComm(record.id)"
      >Attach Lead to Comms
      </button-outlined>
    </div>

  </div>
</template>

<script>
export default {
  name: "LeadBoxMultiple",
  props: {
    records: {
      type: Array,
      required: true
    },
    comms: {
      type: Array,
      required: true
    },
  },
  computed: {
    commIds() {
      return this.comms.map(comm => comm.id)
    }
  },
  methods: {
    status(record) {
      return this.$store.getters["pipeline/getStatusById"](record.current_status_id);
    },
    attachLeadToComm(recordId) {
      const data = {
        comm_ids: this.commIds,
        record_id: recordId
      };

      this.$api.communicationLogs.attachCommsToRecord(data)
        .then(() => {
          this.$buefy.toast.open({message: "Lead is now attached to comms", type: "is-success"});
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.multiple_leads {

  &--heading {
    padding-top: 10px;
    font-size: 1.25rem;
  }

  &--text {
    margin: 6px 0 30px;
    line-height: 1.4;
  }

  &--lead {
    padding: 0 $defaultGap 14px;

    &:not(:last-child) {
      margin-bottom: 14px;
      border-bottom: 1px solid $border;
    }
  }
}
</style>
